import { CrudPage } from './CrudPage'

export const ProcessesAndSectorsPage = () => {
  return <CrudPage />
}